export default __webpack_public_path__ + "static/media/bxl-css3.f4140812.svg";